<template>
  <div :class="['whaty-common-form',type === 'dialog' && 'dialog-form', type === 'drawer' && 'drawer-form']">
      <div v-if="showHeader" class="popup-head">
        <span class="popup-tit">{{ formConfig.title || '&nbsp;' }}</span>
      </div>
    <div v-loading="loading">
        <div class="popup-body">
          <div class="popup-content">
            <div class="clearfix popup-content-in">
              <div class="info form-table-hint" v-show="requiredTips && formConfig.showRequiredTips" style="display: none">
                <i class="mng icon-exclam-fill"></i>带<span class="red">*</span>为必填,不能为空。
              </div>
              <div class="info form-table-hint" v-show="formConfig.tips" style="display: none">
                <i class="mng icon-exclam-fill"></i>
                <div v-html="formConfig.tips" style="display: inline;"></div>
              </div>
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
                <el-tooltip ref="tooltip" :content="tooltipContent" :open-delay="1500"/>
                <template v-for="(column, cindex) in formLyout">
                  <div class="form-table" :style="'width: ' + 100/formLyout.length + '%'" style="float: left">
<!--                  <div class="form-table">-->
                    <ul>
                      <template v-for="(item, index) in editColumns" v-if="index%formLyout.length === cindex">
<!--                        <li class="form-table-row" v-if="index%formLyout.length === cindex">-->
                          <div class="form-table-wrap">
                            <div class="form-table-head"><span>{{item.title}}<span v-show="item.required" class="red">*</span></span></div>
                            <div class="form-table-body">
                              <el-form-item :prop="getDataIndex(item)" label-width="50" initial="off">
                                <!-- input -->
                                <el-input
                                  v-if="item.type === 'text'"
                                  v-model.trim="ruleForm[item.id]"
                                  :placeholder="item.placeholder || item.title">
                                </el-input>
                                <!-- number -->
                                <el-input
                                  v-if="item.type === 'number'"
                                  type="number"
                                  v-model.trim="ruleForm[item.id]"
                                  :placeholder="item.placeholder || item.title">
                                </el-input>
                                <!-- select -->
                                <el-select
                                  :ref="selectRefPrefix + item.uid"
                                  :loading="!!selectLoadingMap[item.uid]"
                                  :no-data-text="selectNoDataTextMap[item.uid] || '无数据'"
                                  v-if="item.type === 'select' || item.type === 'single_select'"
                                  v-model.trim="ruleForm[item.id]"
                                  filterable clearable
                                  @focus="loadSelectData(item)"
                                  @change="handleSelectChange(item)"
                                >
                                  <el-option v-for="p in selectDataList[item.uid]" :key="p[0]" :label="p[1]" :value="p[0]"
                                             :style="{'width':selectOptionWidth + 'px'}"
                                             @mouseenter.native="handleDivMouseEnter($event)"
                                             @mouseleave.native="handleDivMouseleave($event)">
                                  </el-option>
                                </el-select>
                                <!-- remote select -->
                                <whaty-select
                                  v-if="item.type === 'remote_select'"
                                  v-model.trim="ruleForm[item.id]"
                                  :url="remoteSelectDataUrl"
                                  :queryParams="getRemoteSelectQueryParams(item)"
                                  @select-data-change="handleWhatySelectDataChange($event, item)"
                                  @change="handleSelectChange(item)"
                                >
                                </whaty-select>
                                <whaty-cascader
                                  :options="cascadeSelectDataList[item.uid]"
                                  :ref="selectRefPrefix + item.uid"
                                  :loading="!!selectLoadingMap[item.uid]"
                                  :no-data-text="selectNoDataTextMap[item.uid] || '无数据'"
                                  v-if="item.type === 'cascade_select'"
                                  v-model.trim="ruleForm[item.id]"
                                  :props="cascadeSelectPropList[item.uid]"
                                  size="mini" filterable clearable collapse-tags
                                  @focus="loadSelectData(item)"
                                  @change="handleSelectChange(item)"
                                >
                                </whaty-cascader>
                                <!-- date -->
                                <el-date-picker
                                  v-if="item.type === 'month'"
                                  v-model.trim="ruleForm[item.id]"
                                  type="month"
                                  align="left"
                                  :placeholder="item.placeholder || item.title"
                                  format="yyyy-MM"
                                  value-format="yyyy-MM"
                                  size="mini">
                                </el-date-picker>
                                <el-date-picker
                                  :ref="dateRef"
                                  v-if="item.type === 'date'"
                                  v-model.trim="ruleForm[item.id]"
                                  type="date"
                                  align="left"
                                  :placeholder="item.placeholder || item.title"
                                  format="yyyy-MM-dd"
                                  :picker-options="{firstDayOfWeek: 1}">
                                </el-date-picker>
                                <!-- dateTime -->
                                <el-date-picker
                                  :ref="dateRef"
                                  v-if="item.type === 'datetime'"
                                  v-model.trim="ruleForm[item.id]"
                                  type="datetime"
                                  align="left"
                                  :placeholder="item.placeholder || item.title"
                                  format="yyyy-MM-dd HH:mm:ss"
                                  :picker-options="{firstDayOfWeek: 1}">
                                </el-date-picker>
                                <!-- switch -->
                                <el-switch
                                  v-if="item.type === 'switch'"
                                  v-model.trim="ruleForm[item.id]"
                                  active-color="#13ce66"
                                  inactive-color="#ff4949">
                                </el-switch>
                                <!-- checkbox -->
                                <el-checkbox-group
                                  v-if="item.type === 'checkbox'"
                                  v-model.trim="ruleForm[item.id]">
                                  <el-checkbox
                                    v-for="ci in item.checkboxAttributeList"
                                    :key="ci.label"
                                    :label="ci.label">{{ ci.text }}
                                  </el-checkbox>
                                </el-checkbox-group>
                                <!-- file -->
                                <el-upload
                                  v-if="item.type === 'file'"
                                  :ref="'upload_' + item.id"
                                  :action="abstractUploadUrl"
                                  :name="'upload'"
                                  :data="{'uploadField': item.id}"
                                  :headers="uploadHeaders"
                                  :auto-upload="true"
                                  :limit="1"
                                  :on-success="handleFileUploadSuccess"
                                  :on-error="handleFileUploadError"
                                  :on-exceed="handleFileUploadExceed"
                                  class="upload-demo upload-btn"
                                >
                                  <el-button slot="trigger" size="small" type="primary">点击上传</el-button>
                                </el-upload>
                                <!-- image -->
                                <el-upload
                                  class="avatar-uploader"
                                  v-if="item.type === 'image'"
                                  :action="(item.uploadUrl || abstractUploadUrl)"
                                  :name="'upload'"
                                  :data="getUploadExtraParams(item)"
                                  :headers="uploadHeaders"
                                  :show-file-list="false"
                                  :on-success="handleFileUploadSuccess"
                                  :on-error="handleFileUploadError"
                                  :before-upload="handleBeforeImageUpload"
                                >
                                  <img v-if="ruleForm[item.id]" :src="baseUrl+'/'+ruleForm[item.id]" class="avatar">
                                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                              </el-form-item>
                            </div>
                          </div>
<!--                        </li>-->
                      </template>
                    </ul>
                  </div>
<!--                  </div>-->
                </template>
                <div style="float: left; width: 100%;">
                  <ul>
                    <template v-for="(item, index) in textAreaEditColumns">
                      <li class="form-table-wrap" v-if="item.type === 'textArea'">
                          <div class="form-table-head"><span>{{item.title}}<span v-show="item.required" class="red">*</span></span></div>
                          <div class="form-table-body">
                            <el-form-item :prop="getDataIndex(item)" label-width="50">
                              <el-input type="textarea" v-model.trim="ruleForm[item.id]" :rows="4"></el-input>
                            </el-form-item>
                          </div>
                      </li>
                    </template>
                  </ul>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showFooter" class="popup-foot group" :style="{'text-align': (formConfig.footerAlign ? formConfig.footerAlign : 'right')}">
        <a href="javascript:" class="btn btn-solid-primary" @click="handleSubmit">提交</a>
        <a href="javascript:" class="btn btn-anti-default" @click="handleCancel">取消</a>
      </div>
  </div>
</template>
<script>
  import util from '../../libs/util'
  import WhatySelect from '../whaty-select/whaty-select'
  import WhatyCascader from './whaty-cascader'
  import debounce from 'throttle-debounce/debounce'
  import { getStyle } from 'element-ui/src/utils/dom'

  export default {
    name: 'common-form',
    components: {
      WhatyCascader,
      WhatySelect},
    props: {
      /*
         列配置:
              {
                title: '',
                  name: '',
                id: '',
                type: '',
                required: true, // 是否必填
                maxLength: 2000,
                checkRegular: '',
                checkMessage: '',
                canEdit: false, // 是否可以编辑
                value: '', // 初始值
                selectData: [], // 静态下拉数据
                selectDataUrl: '' // 静态下拉数据
              }
      */
      formConfig: {
        type: Object,
        default() {
          return {
            title: '',
            requestConfig: {
              url: '',
              extraParameters: {}
            },
            fields: [],
            tips: '',
            isBean: false, // 参数是否以bean.形式提交,例如bean.name,否则为name
            showRequiredTips: true,
            rootExtraParameters: {} // 额外参数,参数不会拼接在params下
          }
        }
      },
      showHeader: {
        type: Boolean,
        default() {
          return true
        }
      },
      showFooter: {
        type: Boolean,
        default() {
          return true
        }
      },
      type: {
        type: String,
        default() {
          return 'dialog'
        }
      }
    },
    data() {
      let dateValidator = (rule, value, callback) => {
        if (rule.required && !value) {
          callback(new Error(rule.message))
        } else {
          callback()
        }
      }
      return {
        visible: false,
        loading: false,
        // select字段的loading状态
        selectLoadingMap: {},
        // select字段无匹配数据时的提示文本
        selectNoDataTextMap: {},
        // select字段是否load标识
        selectLoadStatusMap: {},
        // 表单布局,例如1,2
        formLyout: [1, 2],
        // form dialog width
        formDialogWidth: '46%',
        // 是否包含必填字段
        requiredTips: false,
        // 下拉框数据储存对象
        selectDataList: {},
        // 级联选择器数据储存对象
        cascadeSelectDataList: {},
        // 级联选择器属性储存对象
        cascadeSelectPropList: {},
        // 级联选择器默认配置
        defaultCascadeConfig: {
          // 指定选项的值为选项对象的某个属性值
          label: 'name',
          // 指定选项标签为选项对象的某个属性值
          value: 'id',
          // 在选中节点改变时，是否返回由该节点所在的各级菜单的值所组成的数组，若设置 false，则只返回该节点的值
          emitPath: false,
          // 是否多选
          multiple: false,
          // 是否严格的遵守父子节点不互相关联
          checkStrictly: true
        },
        // 下拉属性id与name对应关系
        selectListNameAndId: {},
        // 下拉列表初始值
        selectOldValue: {},
        // 表单数据对象
        ruleForm: {},
        // 表单校验规则
        rules: {},
        // textArea字段
        textAreaEditColumns: [],
        // 日期类型字段验证方法
        dateValidator: dateValidator,
        selectRefPrefix: 'form-select-',
        dateRef: 'form-date',
        fieldTypeMap: {}, // 字段类型
        selectOptionWidth: 0, // 下拉框宽度
        tooltipContent: '' // 下拉框气泡显示文字
      }
    },
    computed: {
      // 文件上传时添加的headers
      uploadHeaders: function () {
        return {
          'Authorization': util.bearerToken()
        }
      },
      gridConfigUrl: function () {
        return this.$route.meta.url
      },
      // 下拉框数据获取地址
      selectDataUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'selectData')
      },
      // 下拉框数据获取地址
      cascadeSelectDataUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'cascadeSelectData')
      },
      // 远程下拉框数据获取地址
      remoteSelectDataUrl: function () {
        return this.gridConfigUrl.replace('abstractGrid', 'selectData/search')
      },
      // 文件上传默认地址
      abstractUploadUrl: function () {
        return util.baseUrl + this.gridConfigUrl.replace('abstractGrid', 'abstractUpload')
      },
      // 计算form表单可编辑的列
      editColumns: function () {
        let editColumns = []
        this.ruleForm = {}
        this.textAreaEditColumns = []
        if (this.formConfig && this.formConfig.fields && this.formConfig.fields.length > 0) {
          for (let i = 0; i < this.formConfig.fields.length; i++) {
            let field = this.formConfig.fields[i]
            if (!field.id) {
              console.warn('field.id is undefined')
              continue
            }
            // 如果uid不存在，则补充uid
            if (!field.uid) {
              this.$set(field, 'uid', field.id || field.name)
            }
            // 存在必填字段时,显示必填提示信息
            if (field.required === true) {
              this.requiredTips = true
            }
            // 字段类型没有设置时默认为string
            if (!field.type) {
              field.type = 'string'
            }
            // 如果字段类型是date,并且字段值的类型是number,则使用值创建Date对象
            if (field.type === 'date' && typeof (field.value) === 'number') {
              field.value = new Date(field.value)
            }
            // 收集允许编辑的字段
            if (field.canEdit) {
              this.fieldTypeMap[field.id] = field.type
              if (field.type === 'textArea') {
                this.textAreaEditColumns.push(field)
              } else {
                editColumns.push(field)
              }
              // 根据字段类型,设置form表单数据对象
              if (field.type === 'checkbox') {
                this.$set(this.ruleForm, field.id, [])
              } else {
                this.$set(this.ruleForm, field.id, field.value || '')
              }
              // 级联选择器在计算属性时特别处理，这里设置级联选择器的属性值，以及初始值
              if (field.type === 'cascade_select') {
                let cascadeConfig = {}
                // 级联选择器属性值使用顺序，formConfig>defaultConfig>defaultCascadeConfig
                if (field.extendColumnConfig) {
                  if (field.extendColumnConfig.formConfig) {
                    cascadeConfig = {...field.extendColumnConfig.formConfig}
                  } else if (field.extendColumnConfig.defaultConfig) {
                    cascadeConfig = {...field.extendColumnConfig.defaultConfig}
                  }
                }
                // 属性合并
                this.$set(this.cascadeSelectPropList, field.uid, Object.assign({}, this.defaultCascadeConfig, cascadeConfig))
                // 多选设置空值为数组，单选设置为字符串
                if (cascadeConfig.multiple) {
                  this.$set(this.ruleForm, field.id, field.value || [])
                  this.$set(this.selectOldValue, field.id, field.value || [])
                } else {
                  this.$set(this.ruleForm, field.id, field.value || '')
                  this.$set(this.selectOldValue, field.id, field.value || '')
                  // 单选保存下拉字段的name与id的映射关系
                  this.$set(this.selectListNameAndId, field.id, field.id.replace('_name', '_id'))
                }
              }
              // 初始化字段的验证规则
              this.initRules(field)
            }
            // id作为修改数据的必填属性,即时不能修改也需初始化到form中
            if (field.id === 'id' && field.value) {
              this.$set(this.ruleForm, field.id, field.value)
            }
            // 如果字段是下拉框,保存字段的原始值
            if (field.id.indexOf('_') >= 0) {
              this.$set(this.selectOldValue, field.id, field.value || '')
            }
            // 保存下拉字段的name与id的映射关系
            if (field.id.indexOf('_name') !== -1 && field.type !== 'cascade_select') {
              this.$set(this.selectListNameAndId, field.id, field.id.replace('_name', '_id'))
            }
          }
          // 根据可编辑字段的个数,设置显示样式(单列/两列)
          if (this.type === 'drawer' || (editColumns.length <= 4 && this.type === 'dialog')) {
            this.formLyout = [1]
            this.formDialogWidth = '46%'
          } else {
            this.formLyout = [1, 2]
            this.formDialogWidth = '66%'
          }
        }
        return editColumns
      },
      uidColumnMap: function () {
        let map = {}
        if (this.editColumns && this.editColumns.length > 0) {
          this.editColumns.forEach(item => {
            map[item.uid] = item
          })
        }
        return map
      },
      labelWidth: function () {
        let defaultWidth = 96
        return this.formConfig.labelWidth || defaultWidth
      },
      baseUrl: function() {
        return util.baseUrl
      }
    },
    created() {
      this.activateTooltip = debounce(50, tooltip => tooltip.handleShowPopper())
      // 级联选择组件创建时直接加载数据
      if (this.formConfig && this.formConfig.fields && this.formConfig.fields.length > 0) {
        for (let i = 0; i < this.formConfig.fields.length; i++) {
          let field = this.formConfig.fields[i]
          if (field.type === 'cascade_select') {
            this.loadSelectData(field)
          }
        }
      }
    },
    methods: {
      // 重置form表单
      resetForm() {
        this.$refs['ruleForm'].resetFields()
        this.resetUploadField()
        this.loading = false
        this.selectDataList = {}
        this.selectLoadStatusMap = {}
      },
      // 重置upload字段
      resetUploadField() {
        this.editColumns.map((column) => {
          if (column.type === 'file') {
            let uploadVm = this.$refs['upload_' + column.id]
            if (uploadVm) {
              uploadVm[0].clearFiles()
            }
          }
        })
      },
      getDataIndex(item) {
        return item.id
      },
      // 加载下拉列表数据
      loadSelectData(item) {
        if (item.selectData) { // 本地加载数据
          this.$set(this.selectDataList, item.uid, item.selectData)
        } else { // 远程加载数据
          if (!this.selectLoadStatusMap[item.uid]) {
            // 判断dependColumns是否有值
            if (item.dependColumns && item.dependColumns.length > 0) {
              let dependColumnName = ''
              item.dependColumns.forEach(uid => {
                let column = this.uidColumnMap[uid]
                let key = column.id
                let value = this.ruleForm[key]
                if (!value) {
                  if (dependColumnName) {
                    dependColumnName += '、'
                  }
                  dependColumnName += column.title
                }
              })
              if (dependColumnName) {
                this.$set(this.selectNoDataTextMap, item.uid, '请先选择：' + dependColumnName)
                return
              } else {
                this.$set(this.selectNoDataTextMap, item.uid, '无数据')
              }
            }
            // 设置为select状态为加载中
            this.$set(this.selectLoadingMap, item.uid, true)
            let params = {
              ...this.formConfig.requestConfig.extraParameters,
              'columnDataIndex': item.sqlId || item.name
            }
            // 补充级联参数
            if (item.dependColumns && item.dependColumns.length > 0) {
              let dependColumnValues = {}
              item.dependColumns.forEach(uid => {
                let key = this.uidColumnMap[uid].id
                let value = this.ruleForm[key]
                // //////////////
                // 将xx.name换成xx.id
                if (this.selectListNameAndId[key] && this.selectOldValue[key] === value) { // 如果下拉框的值没有被改变过, 需要将xx.name替换为xx.id
                  let idKey = this.selectListNameAndId[key]
                  value = this.selectOldValue[idKey] || value
                }
                // //////////////
                dependColumnValues[key] = value
              })
              params.dependColumnValues = dependColumnValues
            }
            // 拿到级联选择器配置
            let cascadeConfig = {...this.cascadeSelectPropList[item.id]}
            if (!cascadeConfig || Object.keys(cascadeConfig).length === 0) {
              cascadeConfig = this.getCascadeConfig(item.extendColumnConfig)
            }
            let isCascade = item.type === 'cascade_select'
            // 根据类型来获取相应的数据获取链接
            let url = isCascade ? (cascadeConfig.dataUrl || this.cascadeSelectDataUrl) : (item.selectDataUrl || this.selectDataUrl)
            util.ajax.post(url, {params}).then((res) => {
              if (res.data.meta.errCode === 0) {
                if (isCascade) {
                  this.$set(this.cascadeSelectDataList, item.uid, res.data.data)
                } else {
                  this.$set(this.selectDataList, item.uid, res.data.data)
                }
              } else {
                this.$notify.error({title: '错误', message: res.data.data})
              }
              this.$set(this.selectLoadingMap, item.uid, false)
            }).catch(() => {
              this.$set(this.selectLoadingMap, item.uid, false)
              console.error('获取数据失败！ ' + item.name)
            })
            this.selectLoadStatusMap[item.uid] = true
          }
        }
        this.$nextTick(() => {
          let selectRef = this.$refs[this.selectRefPrefix + item.uid][0]
          if (selectRef) {
            this.selectOptionWidth = selectRef.$el.offsetWidth
          }
        })
      },
      // 从扩展配置中获取级联配置
      getCascadeConfig(extendColumnConfig) {
        let cascadeConfig = {}
        if (extendColumnConfig) {
          if (extendColumnConfig.formConfig) {
            cascadeConfig = {...extendColumnConfig.formConfig}
          } else if (extendColumnConfig.defaultConfig) {
            cascadeConfig = {...extendColumnConfig.defaultConfig}
          }
        }
        return cascadeConfig
      },
      // select的change事件监听
      handleSelectChange(item) {
        // select变化时将它影响的其他select的值置空
        if (item.cascadeColumns && item.cascadeColumns.length > 0) {
          item.cascadeColumns.forEach(uid => {
            if (this.$refs[this.selectRefPrefix + uid] && this.$refs[this.selectRefPrefix + uid][0] && this.uidColumnMap[uid]) {
              // clear form field data
              this.$set(this.ruleForm, this.uidColumnMap[uid].id, '')
              // reset field select data
              this.$set(this.selectDataList, uid, [])
              // reset field cascade-select data
              this.$set(this.cascadeSelectDataList, uid, [])
              // reset field load status
              this.$set(this.selectLoadStatusMap, uid, false)
            }
          })
        }
      },
      handleWhatySelectDataChange(selectData, item) {
        this.$set(this.selectDataList, item.uid, selectData)
      },
      // 初始化表单字段的验证
      initRules(field) {
        let formValidate = []
        let key = field.id
        let type = 'string'
        let maxLength = null
        switch (field.type) {
          case 'date':
            type = 'date'
            break
          case 'datetime':
            type = 'date'
            break
          case 'select':
            type = null
            break
          case 'cascade_select':
            type = 'cascade_select'
            break
          case 'file':
            type = 'file'
            break
          default:
            type = 'string'
        }
        if (type === null) {
          maxLength = null
        }
        if (type === 'string') {
          if (field.maxLength > 0) {
            maxLength = field.maxLength
          } else {
            maxLength = 2000 // 最大长度为空时限制2000字符
          }
        }
        if (type === 'date') {
          formValidate.push({
            type: type,
            required: field.required,
            message: field.checkMessage || ('请输入' + field.title + (maxLength === null ? '' : ',长度不大于' + maxLength + '字符')),
            trigger: 'change',
            validator: this.dateValidator
          })
        } else if (type === 'file') {
          formValidate.push({
            type: 'string',
            required: field.required, // 是否必填
            message: field.checkMessage || '请选择上传文件',
            trigger: 'change'
          })
        } else if (type === 'cascade_select') {
          formValidate.push({
            required: field.required, // 是否必填
            message: field.checkMessage || ('请输入' + field.title + (maxLength === null ? '' : ',长度不大于' + maxLength + '字符')),
            trigger: 'blur'
          })
        } else {
          formValidate.push({
            type: type,
            required: field.required, // 是否必填
            max: maxLength,
            pattern: field.checkRegular || '', // 正则校验
            message: field.checkMessage || ('请输入' + field.title + (maxLength === null ? '' : ',长度不大于' + maxLength + '字符')),
            trigger: 'change'
          })
        }
        this.rules[key] = formValidate
      },
      // 提交按钮处理方法
      handleSubmit() {
        this.$refs['ruleForm'].validate((valid) => {
          // 校验通过
          if (valid) {
            // 将表单值转换成json格式,就是针对"xx.xx.xx"格式的属性进行转换
            let formDataMap = {}
            for (let key in this.ruleForm) {
              let value = this.ruleForm[key] || ''
              // 将xx.name换成xx.id
              if (this.selectListNameAndId[key]) {
                let idKey = this.selectListNameAndId[key]
                if (this.selectOldValue[key] === value) { // 如果下拉框的值没有被改变过, 需要将xx.name替换为xx.id
                  if (this.selectOldValue[idKey]) { // 如果idKey对应有值, 把原来保存的idKey的值作为value
                    value = this.selectOldValue[idKey]
                    util.convertFormToJson(value, formDataMap, idKey, this)
                  } else {
                    util.convertFormToJson(value, formDataMap, key, this)
                  }
                } else {
                  util.convertFormToJson(value, formDataMap, idKey, this)
                }
              } else {
                util.convertFormToJson(value, formDataMap, key, this)
              }
            }
            // 添加/修改
            let params = {}
            if (this.formConfig.isBean) {
              params = {bean: formDataMap, params: this.formConfig.requestConfig.extraParameters}
            } else { // 自定义form表单时,发送额外的参数
              params = {params: {...formDataMap, ...this.formConfig.requestConfig.extraParameters}, ...this.formConfig.rootExtraParameters}
            }
            this.$emit('submit-start')
            this.loading = true
            util.ajax.post(this.formConfig.requestConfig.url, params).then((res) => {
              if (res.data.meta.errCode === 0) {
                let msg = res.data.meta.errMsg || ''
                this.$notify.success({title: '成功', message: msg === 'ok' ? '操作成功' : msg, dangerouslyUseHTMLString: true})
                if (this.formConfig.routerName) {
                  let query = {}
                  for (let key in formDataMap) {
                    if (key === this.formConfig.fieldName) {
                      query[this.formConfig.fieldName] = formDataMap[key]
                    }
                  }
                  let router = {
                    name: this.formConfig.routerName,
                    query: query
                  }
                  this.$emit('change-router', router)
                } else {
                  this.$emit('submit-success')
                }
              } else {
                this.$notify.error({title: '错误', message: res.data.meta.errMsg || '', dangerouslyUseHTMLString: true})
                this.$emit('submit-error')
              }
              this.loading = false
            }).catch((e) => {
              this.$notify.error({title: '错误', message: '提交失败，错误！'})
              console.error(e)
              this.$emit('submit-error')
              this.loading = false
            })
          } else {
            return false
          }
        })
      },
      // 取消按钮处理方法
      handleCancel() {
//        this.resetForm()
//        this.resetUploadField()
        this.$emit('cancel')
      },
      // 文件上传成功钩子
      handleFileUploadSuccess(response, file, fileList) {
        if (response.meta.errCode === 0) {
          // 设置返回的文件路径到ruleForm中
          let uploadField = response.data.uploadField
          this.$set(this.ruleForm, uploadField, response.data.fileSavePath)
        } else {
          this.$notify.warning({title: '警告', message: '上传失败,原因：' + response.meta.errMsg})
        }
      },
      // 文件上传失败钩子
      handleFileUploadError(err, file, fileList) {
        console.error(err)
        let errMsg = '错误,文件上传失败！'
        if (err.message) {
          let message = JSON.parse(err.message)
          if (message.errMsg) {
            errMsg = message.errMsg
          }
        }
        this.$notify.error({title: '错误', message: errMsg})
      },
      // 文件超出个数限制时的钩子
      handleFileUploadExceed(file, fileList) {
        this.$notify.info({title: '提示', message: '添加失败,超出允许上传的文件个数！'})
      },
      handleBeforeImageUpload(file) {
        const isJPG =
          file.type === 'image/jpeg' ||
          file.type === 'image/png' ||
          file.type === 'image/gif' ||
          file.type === 'image/bmp'
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isJPG) {
          this.$notify.error({title: '错误', message: '上传图片只能是 JPG、PNG、GIF、BMP 格式!'})
        }
        if (!isLt2M) {
          this.$notify.error({title: '错误', message: '上传图片大小不能超过 2MB!'})
        }
        return isJPG && isLt2M
      },
      getUploadExtraParams(item) {
        return {
          'uploadField': item.id,
          ...item.extraParams
        }
      },
      getRemoteSelectQueryParams(item) {
        return {
          ...this.formConfig.requestConfig.extraParameters,
          columnDataIndex: item.sqlId || item.name
        }
      },
      // 鼠标移入方法 超出宽度才显示tooltip 并且只渲染一个tooltip
      handleDivMouseEnter(event) {
        const target = event.target
        let child = target.querySelector('span')
        // 如果区域宽度被限定，则通过高度判断
        let heightFlag = false
        // 文本区域
        if (child.scrollHeight > child.offsetHeight) {
          heightFlag = true
        }
        const range = document.createRange()
        range.setStart(child, 0)
        range.setEnd(child, child.childNodes.length)
        const rangeWidth = range.getBoundingClientRect().width // 文本区域宽度
        // 获取padding
        const padding = (parseInt(getStyle(target, 'paddingLeft'), 10) || 0) +
          (parseInt(getStyle(target, 'paddingRight'), 10) || 0)
        // ie浏览器全部显示tooltip
        if (((rangeWidth + padding > target.offsetWidth || child.scrollWidth > child.offsetWidth) || heightFlag || util.isIe()) && this.$refs.tooltip) {
          const tooltip = this.$refs.tooltip
          this.tooltipContent = target.innerText || target.textContent
          tooltip.referenceElm = target
          tooltip.$refs.popper && (tooltip.$refs.popper.style.display = 'none')
          tooltip.doDestroy()
          tooltip.setExpectedState(true)
          this.activateTooltip(tooltip)
        }
      },
      // 鼠标移出方法
      handleDivMouseleave(event) {
        const tooltip = this.$refs.tooltip
        if (tooltip) {
          tooltip.setExpectedState(false)
          tooltip.handleClosePopper()
        }
      },
      closeFormDrop() {
        var myFormRefs = this.$refs
        for (let ref in myFormRefs) {
          var myFormRef = myFormRefs[ref][0]
          if (myFormRef) {
            if (ref.includes('form-select')) {
              myFormRef.blur()
            }
            if (ref.includes('form-date')) {
              myFormRef.handleClose()
            }
          }
        }
      }
    }
  }
</script>
<style lang="scss">
  .whaty-common-form {
    &.drawer-form {
      .form-table-wrap {
        margin: 10px 0;
        padding: 0;
        line-height: 1;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
      }
    }

    &.dialog-form {
      .form-table-wrap {
        margin: 0;
        padding: 8px 12px 8px 12px;
        line-height: 1;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
      }
    }

    .form-table-wrap {
      margin: 0;
      padding: 8px 12px 8px 12px;
      line-height: 1;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    .el-form-item {
      margin-bottom: 0;
    }
    .el-form-item__content {
      line-height: 36px;
    }

    .el-input__inner {
      height: 36px;
      font-size: 14px;
      line-height: 36px;
    }

    .el-input__icon {
      line-height: 36px;
    }

    .el-radio-group,
    .el-checkbox-group {
      display: block;
      line-height: 1;
    }

    .el-select,
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner,
    .el-upload,
    .el-upload-dragger {
      width: 100%;
    }

    input[type="file"].el-upload__input {
      display: none;
    }

    .form-con.form-error .el-input__inner,
    .form-con.form-error .el-input__inner:focus,
    .form-con.form-error .el-textarea__inner,
    .form-con.form-error .el-textarea__inner:focus {
      border-color: #f12c2c;
    }

    .upload-btn .el-upload {
      width: inherit;
    }

    .el-button--small,
    .el-button--small.is-round {
      padding-top: 0;
      padding-bottom: 0;
      height: 36px;
      font-size: 14px;
      line-height: 36px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/grid/common-form.vue